/* eslint-disable react/prop-types */
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import AiLogoButton from "./aiLogoButton";

export default function DialogHeader({
  title,
  handleClose,
  isClosable = true,
}) {
  const theme = useTheme();
  return (
    <>
      {isClosable && (
        <IconButton
          aria-label="close"
          size="small"
          color="primary"
          sx={{ position: "absolute", right: 10 }}
          onClick={handleClose}
          data-dtm="exhibitorHub_smartCompanion_close"
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          gap={1.8}
          fontSize={"3.1rem"}
        >
          <AiLogoButton
            color={theme.palette.secondary.main}
            size="inherit"
            style={{ overflow: "visible" }}
          />
          <Typography
            variant="h6"
            fontWeight={"bold"}
            fontSize={"2.1rem"}
            lineHeight={1.2}
          >
            {title}
          </Typography>
        </Stack>
      </DialogTitle>
    </>
  );
}
